export enum PosConfigurationTypeIdEnum {
  discountEnabled = 12,
  serviceChargeEnabled = 13,
  quickpayEnabled = 1,
  quickpayPaymentMethod = 2,
  tableServiceEnabled = 3,
  sendAndPayEnabled = 4,
  sendAndStayEnabled = 26,
  tableTagEnabled = 28,
  productSearchEnabled = 5,
  flightSearchEnabled = 6,
  disableCustomerReceipt = 27,
  serviceTypeEnabled = 7,
  loyaltyEnabled = 9,
  flagEnabled = 8,
  autoLogoutEnabled = 10,
  inactivityTimeoutSeconds = 11,
  autoRedirectEnabled = 17,
  redirectSeconds = 18,
  defaultScreen = 15,
  productSearchOption = 16,
  orderConfirmationScreen = 19,
  bundleAutocompleteEnabled = 20,
  displayStockEnabled = 24,
  displayProductImageEnabled = 25,
  printLogoImageUrl = 21,
  printBufferLogoImage = 22,
  ageVerificationEnabled = 29,
  vectronIntegrationEnabled = 30,
  staffEnabled = 31
}
